"use client"

import type React from "react"

import { Database } from "lucide-react"
import { Card, CardContent } from "./ui/card"

interface NoDataProps {
  message?: string
  icon?: React.ReactNode
  className?: string
}

export function NoData({ message = "No data available", icon, className = "" }: NoDataProps) {
  return (
    <Card className={`shadow-sm ${className}`}>
      <CardContent className="flex flex-col items-center justify-center py-12 px-6 text-center">
        <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
          {icon || <Database className="w-8 h-8 text-gray-400" />}
        </div>
        <h3 className="text-lg font-medium text-gray-900 mb-2">No Data Found</h3>
        <p className="text-sm text-gray-500 max-w-sm">{message}</p>
      </CardContent>
    </Card>
  )
}
